import React, { useContext } from "react";
import {
  Tooltip,
  Checkbox,
} from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { getUser } from "../../../../../utils/helpers";
import { PendingTableCellContext } from "../../ChemBioPendingContext";
import { ML_SOFTWARE_QC_FLAGS, TEST_OVERDUE_FLAGS, getTestOverdueFlag } from "../../../../../utils/statusConfig";

const GenistaIDList = ({
  testList,
}) => {
  const {
    data,
    chemDropdown,
    tooltipTitle,
    handleGenistaIdOnClick,
    loading,
    handleCheckboxOnChange,
    sampleMap,
    multiSelect,
    extractedColumnMultiSelect,
    enableExtractedColumn,
    handleSequenceCheckbox,
    selectedGenerate,
    mrlTestSet,
  } = useContext(PendingTableCellContext);
  return (
    <div className="PendingTableCellContentContainer">
      {testList.map((p, index) => {
        let disablePopup = !p.sample_status || !chemDropdown || !data.instrument_name;
        if (p.sample_status === "load" || p.sample_status === "analyze") {
          disablePopup = !getUser()?.permissionMap.change_results || p.loaded_on_instruments.length >= 2;
        }
        const cursor = disablePopup ? "" : "pointer";
        let overdueFlagStyle = TEST_OVERDUE_FLAGS[getTestOverdueFlag(p.overdue_by)]?.textStyle;
        if (p.status === "Retest") {
          overdueFlagStyle = { ...overdueFlagStyle, ...TEST_OVERDUE_FLAGS.Retest.textStyle };
        }
        const genCellClass = `GenIdCell ${cursor ? "GenIdCursor--pointer" : ""}`;
        const modalTest = {
          ...p,
          test: data.Test,
          instrument_name: data.instrument_name,
          instrument_id: data.instrument_id,
          isMRLTest: mrlTestSet.has(data.Test),
        };
        const iconColor = ML_SOFTWARE_QC_FLAGS[p.ml_soft_qc_result || 0]?.style?.color;
        const qcIconMap = {
          1: <CheckCircleOutlined style={{ color: iconColor }} className="PendingTable__QCStatus--pass" />,
          2: <CloseCircleOutlined style={{ color: iconColor }} className="PendingTable__QCStatus--error" />,
          3: <InfoCircleOutlined style={{ color: iconColor }} className="PendingTable__QCStatus--unknown" />,
        };
        const childNode = (
          <Tooltip
            key={`genista_tooltip_${index}`}
            placement="top"
            title={() => (tooltipTitle ? tooltipTitle(modalTest) : "")}
            overlayClassName="PendingTable__Tooltip"
            overlayStyle={{ minWidth: "350px" }}
          >
            <span
              className={genCellClass}
              style={overdueFlagStyle}
              onClick={() => handleGenistaIdOnClick(disablePopup, modalTest)}
            >
              {index + 1
                === testList.length
                ? `${p[Object.keys(p)[1]]}`
                : `${p[Object.keys(p)[1]]}${multiSelect ? "" : ", "}`}
              {p.sample_status === "analyze" && qcIconMap[p.ml_soft_qc_result]}
            </span>
          </Tooltip>
        );
        if (multiSelect) {
          return (
            <div key={index} className="PendingTable__GenistaCell">
              <Checkbox
                disabled={loading || enableExtractedColumn}
                onChange={(e) => handleCheckboxOnChange(e, p)}
                checked={sampleMap.has(p.test_in_sample_id)}
              />
              {childNode}
            </div>
          );
        }
        if (extractedColumnMultiSelect && enableExtractedColumn) {
          return (
            <div key={index} className="PendingTable__GenistaCell">
              <Checkbox disabled={loading} onChange={(e) => handleSequenceCheckbox(e, p)} checked={selectedGenerate.get(p.sample_status).has(p.test_in_sample_id)} />
              {childNode}
            </div>
          );
        }
        return (childNode);
      })}
    </div>
  );
};

export default GenistaIDList;
